// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"UpSellTooltip_tooltip__y9D5f","trigger":"UpSellTooltip_trigger__i9JXk","open":"UpSellTooltip_open__vfO3Q","content":"UpSellTooltip_content__Nulw_"};